import { render, staticRenderFns } from "./changepw.vue?vue&type=template&id=47cf3712&"
import script from "./changepw.vue?vue&type=script&lang=js&"
export * from "./changepw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports